import classcat from "classcat";
import React from "react";

import { Logo } from "@is/components/Logo";
import { PaymentStatus } from "@is/constants";

import css from "./PaymentStatusPage.module.css";
import useManagePaymentStatusPage from "./hooks/useManagePaymentStatusPage";

type Props = {
  paymentStatus: PaymentStatus;
};

const PaymentStatusPage = ({ paymentStatus }: Props) => {
  const { title, subtitle, isDesktop } = useManagePaymentStatusPage({
    paymentStatus,
  });

  return (
    <div className={css.container}>
      <div className={css.titleContainer}>
        {title}
        <span
          className={classcat([
            { ["text-label-lg"]: isDesktop },
            { ["text-label-base"]: !isDesktop },
          ])}
        >
          {subtitle}
        </span>
      </div>
      <div className={css.footer}>
        <Logo className={css.logo} />
      </div>
    </div>
  );
};

export default PaymentStatusPage;
